"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var react_1 = __importStar(require("react"));

var react_spring_1 = require("react-spring");

var styled_1 = __importDefault(require("@emotion/styled"));

var theme_1 = require("../../../styles/theme");

var NavLinks_1 = __importDefault(require("./NavLinks"));

var SideBarContainer = styled_1["default"]('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n"], ["\n  ", " {\n    display: none;\n  }\n"])), theme_1.theme.breakpoints.tabletLandscapeUp);
var Main = styled_1["default"](react_spring_1.animated.div)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: 1px 0 10px rgba(0, 0, 0, 0.25);\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 18.75rem;\n  z-index: 100;\n"], ["\n  background-color: ", ";\n  box-shadow: 1px 0 10px rgba(0, 0, 0, 0.25);\n  height: 100vh;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 18.75rem;\n  z-index: 100;\n"])), theme_1.theme.colors.White);
var Container = styled_1["default"]('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  padding: 1.5rem 1.5rem 1.5rem calc(10% + 1.5rem);\n\n  a:first-of-type {\n    margin-bottom: 1em;\n  }\n"], ["\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  padding: 1.5rem 1.5rem 1.5rem calc(10% + 1.5rem);\n\n  a:first-of-type {\n    margin-bottom: 1em;\n  }\n"])));
var TrackComponentName = 'Sidebar';

var Sidebar = function Sidebar(_a) {
  var setSidebarVisible = _a.setSidebarVisible,
      show = _a.show,
      track = _a.track;
  var sidebarRef = react_1.useRef();
  var transition = react_spring_1.useTransition(show, null, {
    from: {
      transform: 'translateX(-100%)'
    },
    enter: {
      transform: 'translateX(-10%)'
    },
    leave: {
      transform: 'translateY(-100%)'
    },
    unique: true,
    config: react_spring_1.config.stiff,
    ref: sidebarRef
  });
  react_spring_1.useChain([sidebarRef]);
  return react_1["default"].createElement(react_1["default"].Fragment, null, transition.map(function (_a) {
    var item = _a.item,
        key = _a.key,
        props = _a.props;
    return item ? react_1["default"].createElement(SideBarContainer, {
      key: key
    }, react_1["default"].createElement(Main, {
      style: props
    }, react_1["default"].createElement(Container, null, react_1["default"].createElement(NavLinks_1["default"], {
      track: track,
      trackComponentName: TrackComponentName,
      setSidebarVisible: setSidebarVisible
    })))) : null;
  }));
};

Sidebar.displayName = TrackComponentName;
exports["default"] = Sidebar;
var templateObject_1, templateObject_2, templateObject_3;